const { React_APP_API_URL } = process.env

// ** Auth Endpoints
export default {
  loginEndpoint: `${React_APP_API_URL}/auth/login`,
  registerEndpoint: `${React_APP_API_URL}/auth/register`,
  registerSupplierEndpoint: `${React_APP_API_URL}/auth/register_supplier`,
  registerClientEndpoint: `${React_APP_API_URL}/auth/register_client`,
  refreshEndpoint: `${React_APP_API_URL}/auth/refresh-token`,
  logoutEndpoint: `${React_APP_API_URL}/auth/logout`,
  rolelist: `${React_APP_API_URL}/roles`,
  orders: `${React_APP_API_URL}/orders`,

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
